import { db, firebase } from "../../../config/firebase/firebase-config";
import { IResponseFirebase } from "../../../interfaces/firebase";
import { ITrdSeries, ITrdVersion } from "../../../redux/types/types";
import moment from "moment";
import { IValidateProductionOffice } from "../form/IValidateProductionOffice";

export const setTrdSerie = async (
  idEntity: string,
  serie: ITrdSeries,
  seriesArr: any
): Promise<IResponseFirebase> => {
  try {
    const docRef = db.collection("Entities").doc(idEntity);

    await docRef
      .collection("Series")
      .doc(serie.idSerie)
      .set({
        ...serie,
        createAt: firebase.firestore.Timestamp.now(),
      });
    await docRef
      .collection("TRD")
      .doc(serie.idVersion)
      .set(
        {
          series: [...seriesArr],
        },
        { merge: true }
      );
    return {
      ok: true,
    };
  } catch (error) {
    return {
      ok: false,
      data: error,
    };
  }
};

//SERIES
export const getTrdSeries = async (idEntity: string): Promise<ITrdSeries[]> => {
  const snap = await db
    .collection("Entities")
    .doc(idEntity)
    .collection("Series")
    .get();
  let response: ITrdSeries[] = [];
  snap.forEach((doc) => {
    response.push(doc.data() as ITrdSeries);
  });
  return response;
};

export const setTrdVersion = async (
  idEntity: string,
  version: ITrdVersion
): Promise<IResponseFirebase> => {
  try {
    const docRef = db.collection("Entities").doc(idEntity);

    await docRef
      .collection("TRD")
      .doc(version.idVersion)
      .set(
        {
          ...version,
          approvalDate: (version.approvalDate as firebase.firestore.Timestamp)
            .toDate
            ? version.approvalDate
            : firebase.firestore.Timestamp.fromDate(
                moment(version.approvalDate).toDate()
              ),
          series:
            version.series && version.series.length > 0 ? version.series : null,
        },
        { merge: true }
      );
    return {
      ok: true,
    };
  } catch (error) {
    return {
      ok: false,
      data: error,
    };
  }
};

export const deleteTrdSerie = async (
  idEntity: string,
  idSerie: string
): Promise<IResponseFirebase> => {
  try {
    const docRef = db
      .collection("Entities")
      .doc(idEntity)
      .collection("Series")
      .doc(idSerie);
    const subSerieSnap = await docRef.collection("SubSeries").limit(1).get();
    if (subSerieSnap.empty) {
      await docRef.delete();
      return {
        ok: true,
      };
    } else {
      return {
        ok: false,
      };
    }
  } catch (error) {
    return {
      ok: false,
      data: error,
    };
  }
};

export const validateSeriesCreated = async (
  value: IValidateProductionOffice
) => {
  const seriesSnap = await db
    .collection("Entities")
    .doc(value.idEntity)
    .collection("Series")
    .where("idProductionOffice", "==", value.idProductionOffice)
    .get();

  let series: any[] = [];

  seriesSnap.forEach((snap) => {
    series.push({
      id: snap.id,
      ...snap.data(),
    });
  });

  return series;
};

export const loadSeriesById = async (
  data: IValidateProductionOffice
): Promise<any | null> => {
  const snap = await db
    .collection("Entities")
    .doc(data.idEntity)
    .collection("Series")
    .where("idSerie", "==", data.idProductionOffice.toString())
    .limit(1)
    .get();
  if (snap.empty) {
    return null;
  }
  let response: any;
  snap.forEach((doc) => {
    response = doc.data() as any;
  });
  return response;
};
